/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
    Category,
    Image,
    ListingItem,
    Meta,
    ServerRequest,
    TextBlock,
} from "@lib/shared/types";
import { SectionRules } from "@page-builder/ts/types";
import HTTP, { apiHandler } from "@services/http.service";
import { AxiosError, AxiosRequestConfig } from "axios";
import { Page, TemplateConfig } from "@page-builder/ts/types";
import { HandledPreDefinedAnswerSummaryConfigSlugs } from "@components/shared/form/answerSummary/preDefinedConfigs";
import { AnswerSummaryConfigs } from "@components/shared/form";
import {
    getAccessToken,
    getLocale,
    getTestVariantId,
    getUserState,
} from "@lib/shared/cookies";
import { filterOfferByQueryParams } from "@lib/serverUtils";
import { ParsedUrlQuery } from "querystring";
export interface DomainInfoResponse {
    data: DomainInfo | null;
    success: boolean;
}

interface ProxiedNumber {
    phoneNumber: string;
    categorySlug: string;
    category: string;
    categoryId: number;
    ts: string;
}
export interface HotTortsItem {
    icon?: string;
    name?: string;
    brief?: string;
    criteria?: string;
    slug?: string;
    headline?: string;
    "sub-headline"?: string;
    "action-button-headline"?: string;
    "form-headline"?: string;
}

export interface TeamMember {
    name: string;
    image: string;
    position: string;
}

export type categoriesList = {
    name: string;
    slug: string;
}[];

export type bestContractorsInfo = {
    headerList: {
        name: string;
        link: string;
        hasDropdown?: boolean;
        className?: string;
    }[];
    servicesList: {
        longTitle: string;
        shortTitle: string;
        categories: categoriesList;
    }[];
    educationalList: {
        title: string;
        link: string;
        content: string;
    }[];
    popularCategories: categoriesList;
    educationalHubLink: string;
    ourServicesLink: string;
};
type ConditionOperation =
    | "includes"
    | "not_include"
    | "exist"
    | "does_not_exist";
type LogicalOperator = "and" | "or";

export interface Condition {
    lookupCondition: string;
    operation: ConditionOperation;
    value?: string;
}

export interface Rule {
    operator: LogicalOperator;
    conditions: Condition[];
}

export interface HideDoNotSellCriteria {
    operator: LogicalOperator;
    rules: Rule[];
}
export interface DomainConfig {
    alwaysApplyDkis?: boolean;
    captureWebVitals?: boolean;
    showSmsTCPA?: boolean;
    sellingPoint?: string;
    goToThankYouPage?: boolean;
    sellingPointsSteps?: "FIRST_STEP" | "ALL_STEPS" | undefined;
    dynamicThankYouFields?: string[];
    withSideWidget?: boolean;
    disableAutoWarrantyMakersList?: boolean;
    popupStyle?: {
        actionBtnBgColor?: string;
        actionBtnColor?: string;
        iconColor?: string;
    };
    withForm?: boolean;
    formSideContent?: string;
    pages?: {
        [key: string]: Page;
    };
    header?: {
        variables?: {
            [key: string]: string;
        };
    };
    footer?: {
        variables?: {
            [key: string]: string;
        };
    };
    countryCodeColors?: {
        textColor?: string;
        clickHereColor?: string;
    };
    bannerBgColor?: string;
    bannerTextColor?: string;
    sliderLogos?: { [key: string]: { path: string; slug: string }[] };
    leadCapture?: boolean;
    useBingEnhancedConversion?: boolean;
    primaryColor?: string;
    stickyButtonTextColor?: string;
    stickyButtonBgColor?: string;
    offersPage?: {
        heroBg?: string;
        formBg?: string;
        insuranceListingTitle?: string;
    };
    smsTCPALinkColor?: string;
    headerBackgroundColor?: string;
    sloganTextColor?: string;
    stickyPulseColor?: string;
    clickToCallBorder?: string;
    clickToCallBtnBackground?: string;
    clickToCallBtnForground?: string;
    clickToCallBtnShadow?: string;
    css?: string;
    answerSummaryConfigs?: AnswerSummaryConfigs;
    preDefinedAnswerSummaryConfigs?: HandledPreDefinedAnswerSummaryConfigSlugs;
    header_phone_number?: string;
    team: {
        all: TeamMember[];
        main: TeamMember;
        header: string;
        paragraph_1: string;
        paragraph_2: string;
    };
    hot_torts: HotTortsItem[];
    showFormInsideOffersModal?: boolean;
    listSlug?: string;
    hideLegalNotice?: boolean;
    hideDoNotSell?: boolean;
    winnerBuyerLoadingContainerBgColor?: string;
    winnerBuyerLoadingIconColor?: string;
    callUsStickyTitle?: string;
    formFieldsConfig?: {
        // codeName
        [key: string]: {
            // value
            [key: string]: {
                icon?: string;
                label?: string;
            };
        };
    };
    globalPageUseSecondaryLogo?: boolean;
    //bestcontractors.com domain specific
    bestContractorsInfo?: bestContractorsInfo;
    //bestcontractors.com domain specific
    isBranded?: boolean;
    hideDoNotSellInFooter?: HideDoNotSellCriteria;
    exitModalFormStepsConfig?: {
        title?: { [key: string]: string } | string;
        includeTCPAMessage?: boolean;
        fieldsCodeNames:
            | string[]
            | { [key: string]: { [key: string]: string } };
        buttonText?: { [key: string]: string } | string;
    }[];
    disclaimerNote?: string;
    autoSell?: boolean;
    shouldHideSectionsAfterFirstAnswer?: boolean;
    showPreFirstStepTitle?: boolean;
    forceOldForm?: boolean;
    tcpaPosition?: "aboveSubmitButton" | "bottom";
    enableRejectedAnswers?: boolean;
    renderAllSectionsImmediately?: boolean;
    rejectedAnswersRules?: SectionRules[][];
}

export interface Menu {
    id: number;
    name: string;
    slug: string;
    links: { id: number; title: string; link: string }[];
    items: { title: string; link: string }[];
}

export interface DomainInfo {
    id: number;
    name: string;
    niceName: string;
    title: string;
    slogan: string;
    type: "clicks" | "lead" | "affiliate" | "informational";
    description: string;
    clickyCodeId: string | null;
    analyticsCodeId: string | null;
    gtmId: string | null | undefined;
    favicon: Image | null;
    isInspectorEnabled: boolean;
    categories: Category[];
    logo: Image | null;
    secondaryLogo: Image | null;
    enableJornayaId: boolean;
    enableTrustedForm: boolean;
    twitterPixel: string;
    metatags: Meta[];
    showForm: boolean;
    listings: [
        {
            id: number;
            name: string;
            slug: string;
            isComparison: boolean;
            topOffer: null;
            icon: Image | null;
        },
    ];
    defaultOffers: ListingItem[];
    proxiedNumbers: ProxiedNumber[];
    recaptchaConfig: {
        key: string;
        secret: string;
    };
    advertisingNetworkTrackingSettings: {
        pixelId: string;
        network?: string;
    };
    config?: Partial<DomainConfig>;
    settings?: { isSecondServiceEnabled: boolean };
    textBlocks: TextBlock[];
    templateConfig: TemplateConfig;
    notificationsSettings?: {
        pushAppId?: string;
        safari_web_id?: string;
        pushOptions?: PushOptions;
    };
    fallbackSettings?: { domain: string; excludedBuyers: number[] } | null;
    translations?: { [key: string]: string };
    allowedLanguages?: string[];
    menus?: Menu[];
    menusList?: Menu[];
}

export interface PushOptions {
    promptOptions?: {
        text: {
            actionMessage: string;
            acceptButton: string;
            cancelButton: string;
        };
    };
    notifyButton?: {
        enable: boolean;
        size: "small" | "medium" | "large";
        position: "bottom-left" | "bottom-right";
        offset: {
            bottom: string;
            left: string;
            right: string;
        };
    };
}

export const getDomainInfo = async ({
    req,
    categorySlug,
    stateCode,
}: {
    req?: ServerRequest;
    categorySlug: string | undefined | null;
    stateCode: string | undefined | null;
}): Promise<{
    data: DomainInfo | null;
    error: AxiosError | null;
}> => {
    const accessToken = req ? req.accessToken : getAccessToken();
    const finalStateCode = getUserState() ?? stateCode;
    const searchParams = new URLSearchParams();
    const styleTestVariantId = getTestVariantId("style", null, req);
    const templateTestVariantId = getTestVariantId("template", null, req);

    if (categorySlug) {
        searchParams.append("categorySlug", categorySlug);
    }
    if (finalStateCode) {
        searchParams.append("stateCode", String(finalStateCode));
    }

    if (templateTestVariantId || styleTestVariantId) {
        searchParams.append(
            "variantId",
            String(templateTestVariantId || styleTestVariantId),
        );
    }

    const config: AxiosRequestConfig = {
        method: "get",
        url: `/api/web/v2/info${
            searchParams.toString() ? `?${searchParams.toString()}` : ""
        }`,
        headers: {
            "X-DOMAIN-NAME": `${req ? req?.headers?.host ?? "" : ""}`,
            Authorization: `Bearer ${accessToken as string}`,
            "X-Language": req ? req.locale ?? "en" : getLocale(),
        },
    };

    const { data: domainInfoResponse, error } =
        await apiHandler<DomainInfoResponse>(() => HTTP.server(config));

    return {
        data: domainInfoResponse?.data
            ? {
                  ...domainInfoResponse.data,
                  defaultOffers: domainInfoResponse.data.defaultOffers.filter(
                      (offer) => {
                          return filterOfferByQueryParams({
                              placement: offer.placements.hideBasedOnParameters,
                              query: req?.query,
                              parameterFunction:
                                  offer.placements.parametersFunction,
                          });
                      },
                  ),
              }
            : null,
        error,
    };
};

interface UpdatedOffers {
    defaultOffers: ListingItem[];
    formOffer?: ListingItem[];
    exitModalOffer?: ListingItem[];
    thankYouOffers?: ListingItem[];
    headerOffer?: ListingItem[];
    stickyOffer?: ListingItem[];
}

export const updateDomainOffers = async ({
    categorySlug,
    stateCode,
    isMobile,
    query,
}: {
    categorySlug: string | undefined | null;
    stateCode: string | undefined | null;
    isMobile: boolean;
    query: ParsedUrlQuery;
}): Promise<{
    data: UpdatedOffers | null;
    error: AxiosError | null;
}> => {
    const searchParams = new URLSearchParams();

    if (categorySlug) {
        searchParams.append("categorySlug", categorySlug);
    }
    if (stateCode) {
        searchParams.append("stateCode", stateCode);
    }
    if (isMobile) {
        searchParams.append("isMobile", String(isMobile));
    }
    if (query) {
        for (const [key, value] of Object.entries(query)) {
            searchParams.append(key, String(value));
        }
    }

    const config: AxiosRequestConfig = {
        method: "get",
        url: `/api/update-offers${
            searchParams.toString() ? `?${searchParams.toString()}` : ""
        }`,
    };

    const { data, error } = await apiHandler<{ data: UpdatedOffers }>(() =>
        HTTP.client(config),
    );

    if (!data) {
        return {
            data: null,
            error,
        };
    }

    return {
        data: data.data,
        error,
    };
};
